import { baseApiV2 } from '@verantos-dev/app-state-base';
import { PROJECTS_BASE_PATH } from '@verantos-dev/core-constants';
import { type ListResponse } from '@verantos-dev/types-common';
import { type ConceptGroup } from '@verantos-dev/types-concepts';

/**
 * apiSlice.ts
 *
 */
// inject endpoints for feature into the baseApi
export const conceptGroupsApiSlice = baseApiV2.injectEndpoints({
  endpoints: (builder) => ({
    // Queries: for more information see: https://redux-toolkit.js.org/rtk-query/usage/queries
    // getter endpoint
    getConceptGroups: builder.query<ListResponse<ConceptGroup>, string>({
      // define the endpoint for the query
      query: (projectId: string) => `${PROJECTS_BASE_PATH}/${projectId}/concept-groups`,
    }),

    // Mutations: for more information see: https://redux-toolkit.js.org/rtk-query/usage/mutations
    // if you want to perform a post or put, rather than builder.query, you would use builder.mutation
    // addPokemon: builder.mutation<any,any>()
  }),
});

// export hooks to access/fetch data
export const { useGetConceptGroupsQuery } = conceptGroupsApiSlice;

// in container components, access state from the slice
// const { data: users, isLoading, isSuccess, isError, error } = useGetPokemonByNameQuery('pikachu');
